import { Pagination, PaginationContent } from "../ui/pagination";
import { cn } from "@/lib/utils";

export interface PaginationState {
  total: number;
  totalPages: number;
  page: number;
  limit: number;
}

export interface DataPaginationProps {
  pagination?: PaginationState;
  onPaginationChange?: (pagination: PaginationState) => void;
  itemsPerPageOptions?: number[];
  disabled?: boolean;
  className?: string; // Adicionado para permitir customização de margem/padding externo
}

const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

export const DEFAULT_PAGINATION = {
  total: 0,
  totalPages: 0,
  page: 1,
  limit: 20,
};

export function DataPagination(props: Readonly<DataPaginationProps>) {
  const {
    pagination = DEFAULT_PAGINATION,
    onPaginationChange = () => {}, // Valor default para evitar erro se não for passado
    itemsPerPageOptions = DEFAULT_ITEMS_PER_PAGE_OPTIONS,
    className,
  } = props;

  // Se não houver itens ou páginas, podemos optar por não renderizar nada ou renderizar desabilitado
  if (pagination.total === 0 && pagination.totalPages === 0) {
    return null;
  }

  return (
    <div className={cn("w-full border-t border-border/40 p-2", className)}>
      <Pagination>
        <PaginationContent
          currentPage={pagination.page || 1}
          totalPages={pagination.totalPages || 1}
          onPageChange={(page) => onPaginationChange({ ...pagination, page })}
          itemsPerPage={pagination.limit || itemsPerPageOptions[0]}
          itemsPerPageOptions={itemsPerPageOptions}
          onItemsPerPageChange={(limit) => {
            // Quando muda o limite, geralmente voltamos para a página 1 para evitar bugs de offset
            onPaginationChange({ ...pagination, limit, page: 1 });
          }}
          totalItems={pagination.total}
        />
      </Pagination>
    </div>
  );
}
